<template>
    <div class="lms__superadmin_workspaces_edit_certificates_table">
        <component-table
            :labels="[
                {
                    key: 'name',
                    title: 'Certificate name',
                    type: 'string'
                },
                {
                    key: 'status',
                    title: '',
                    type: 'string'
                },
                {
                    key: 'actions',
                    title: '',
                    type: 'string'
                }
            ]"
            :items="items"
            :component-table-item="LmsSuperadminWorkspaceEditCertificatesTableItem"
            :sort-queryable="sortQueryable"
            @emit-preview="handlePerformEmit({ message: 'emit-preview', value: arguments[0] })"
            @emit-set-default="handlePerformEmit({ message: 'emit-set-default', value: arguments[0] })"
            @emit-unset-default="handlePerformEmit({ message: 'emit-unset-default', value: arguments[0] })"
            @emit-edit="handlePerformEmit({ message: 'emit-edit', value: arguments[0] })"
            @emit-delete="handlePerformEmit({ message: 'emit-delete', value: arguments[0] })"
            @emit-sort="handleSort"
            @emit-perform-get-items="emitPerformGetItems"
        />
    </div>
</template>

<script>

import ComponentTable from '@/components/default/shared/ComponentTable'
import LmsSuperadminWorkspaceEditCertificatesTableItem from '@/components/lms/superadmin/workspace/edit/LmsSuperadminWorkspaceEditCertificatesTableItem'

export default {
  name: 'lms-superadmin-workspace-edit-certificates-table',
  components: { ComponentTable },
  data () {
    return {
      LmsSuperadminWorkspaceEditCertificatesTableItem
    }
  },
  props: {
    items: {
      type: [Array, Object]
    },
    sortQueryable: {
      type: Boolean
    },
    componentTableAddActive: {
      type: Boolean
    }
  },
  methods: {
    handlePerformEmit (data) {
      const message = data.message
      const value = data.value
      this.$emit('emit', { message: message, value: value })
    },
    handleSort (data) {
      this.$emit('emit-sort', data)
    },
    emitPerformGetItems (data) {
      this.$emit('emit-perform-get-items')
    }
  }
}
</script>
